<template>
  <div class="modal-card">
    <header class="modal-card-head">
      <p class="modal-card-title">Example Previews</p>
      <button type="button" class="delete" @click="$emit('close')" />
    </header>
    <section class="modal-card-body">
      <div class="board-previews">
        <BoardPreview
          v-for="(scenario, index) in scenarios"
          :key="index"
          :scenario="scenario"
          :index="index"
          :is-selected="scenario.id === selectedScenarioId"
          :board-size="176"
          @click="handleScenarioClick(scenario)"
        />
      </div>
    </section>
  </div>
</template>

<script>
import BoardPreview from "@/components/training/explorer/molecules/BoardPreview.vue";

export default {
  name: "ScenariosSelector",

  components: {
    BoardPreview,
  },

  props: {
    scenarios: {
      type: Array,
      required: true,
    },
    selectedScenarioId: {
      type: String,
      default: null,
    },
  },

  methods: {
    handleScenarioClick(scenario) {
      this.$emit("select", scenario);
      this.$emit("close");
    },
  },
};
</script>

<style scoped>
.modal-card {
  width: 100%;
  max-width: 1160px;
  max-height: 80vh;
  display: flex;
  flex-direction: column;
}

.modal-card-body {
  max-height: calc(80vh - 100px);
  overflow-y: auto;
}

.board-previews {
  display: flex;
  flex-wrap: wrap;
  gap: 1rem;
  justify-content: center;
  margin-bottom: 1.5rem;
}
</style>
